import { render, staticRenderFns } from "./RequestCard.vue?vue&type=template&id=6aaa2287&scoped=true&"
import script from "./RequestCard.vue?vue&type=script&lang=js&"
export * from "./RequestCard.vue?vue&type=script&lang=js&"
import style0 from "./RequestCard.css?vue&type=style&index=0&id=6aaa2287&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa2287",
  null
  
)

export default component.exports